export const qs   = (sel, ctx = document) => ctx.querySelector(sel);
export const qsa  = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
export const on   = (el, ev, fn, opts)    => el.addEventListener(ev, fn, opts);
export const html = (el, string)          => { el.innerHTML = string; return el; };